import { useState, useRef, useEffect } from "react";
import { getProductsAll } from "../../Services/ProductService";
import { getLanguages } from "../../Services/LanguageService";
import { getSegmentAll } from "../../Services/SegmentService";
import { getCategoryAll } from "../../Services/CategoryService";
import { getSubcategoryAll } from "../../Services/SubcategoryService";
import { getExportFile, getImportFile } from "../../Services/FileService";
import Overlay from "../../Components/Overlay/Overlay";
import MTable from "../../Components/MTable/MTable";
import { NavLink, useNavigate } from "react-router-dom";
import { uuid } from "../../Utils/Utils";
import { useSelector } from "react-redux";
import { InputSwitch } from "primereact/inputswitch";
import Modal from "../../Components/Layout/Modal";
import { check, send } from "../../Images/index";
import CountryFlag from "../../Components/CouontryFlag/CountryFlag";
import { getAllAssembles } from "../../Services/AssemblyServices";

const { $ } = window;
const modalId = "#product-list-modal";

const ProductPageView = () => {
  let { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const mTable = useRef();
  const [showAll, setShowAll] = useState(false);

  const [state, setState] = useState({
    checked: [],
    checkAll: [],
    customFilter: "",
    segments: [],
    categories: [],
    subcategories: [],
    products: [],
    params: {},
    selectedItem: null,
    languages: [],
    assembles: [],
    lang_code_1: null,
    lang_code_2: null,
    assembly: null,
    fileExport: null,
    files: [],
    processing: false,
    processing2: false,
  });

  const setChange = (e) => {
    if (e.target.name === "id_segment") {
      if (e.target.value == "") {
        setState({ ...state, params: null, categories: [], subcategories: [] });
      } else {
        getCategoryAll({
          perpage: 100,
          filter: `id_segment:${e.target.value}`,
        }).then((res) => {
          setState({
            ...state,
            categories: res.data.data,
            params: { [e.target.name]: e.target.value },
          });
        });
      }
    } else if (e.target.name === "id_category") {
      if (e.target.value == "") {
        setState({ ...state, subcategories: [] });
      } else {
        getSubcategoryAll({
          perpage: 100,
          filter: `id_category:${e.target.value}`,
        }).then((res) => {
          setState({
            ...state,
            subcategories: res.data.data,
            params: { [e.target.name]: e.target.value },
          });
        });
      }
    } else if (e.target.name === "id_sub_category") {
      if (e.target.value != "") {
        setState({
          ...state,
          params: { [e.target.name]: e.target.value },
        });
      }
    }
  };

  const onAddData = () => {
    if (!userInfo.access.master_product.can_create) {
      return;
    }
    navigate("add/new");
  };

  const onRowClick = (item) => {
    setState({ ...state, selectedItem: item });
    setTimeout(() => {
      $(modalId).modal("show");
    }, 150);
  };

  const columns = [
    {
      id: uuid(),
      title: "Code",
      field: "item_code",
      style: { width: 85 },
      sortable: true,
      clickable: true,
    },
    {
      id: uuid(),
      title: "Model",
      field: "model_code",
      sortable: true,
      style: { width: 120 },
      clickable: true,
    },
    {
      id: uuid(),
      title: "Name",
      field: "item_name",
      style: { width: 205 },
      sortable: true,
      clickable: true,
    },
    {
      id: uuid(),
      title: "Series",
      field: "series",
      style: { width: 55 },
      sortable: true,
      clickable: true,
    },
    {
      id: uuid(),
      title: "Segment",
      field: "segment_name",
      sortable: false,
      style: { width: 55 },
      clickable: true,
    },
    {
      id: uuid(),
      title: "Category",
      field: "category_name",
      sortable: false,
      clickable: true,
      style: { width: 55 },
    },
    {
      id: uuid(),
      title: "Country",
      field: "country_name",
      style: { width: 55 },
      sortable: true,
      clickable: true,
      render: (item) => {
        return item.country_name ? <p>{item.country_name}</p> : <p className="text-red">Not Set</p>;
      },
    },
    {
      id: uuid(),
      title: "Created by",
      field: "created_by",
      sortable: false,
      clickable: true,
      style: { width: 55 },
    },
    {
      id: uuid(),
      title: "Approval",
      field: "is_creation_approved",
      sortable: false,
      filterable: false,
      style: { width: 55 },
      render: (item) => {
        if (item.is_creation_approved == false) {
          if (item.incident_status == "ONPROGRESS" || item.incident_status_detail == "ONPROGRESS") {
            return (
              <span className="badge badge-info" style={{ color: "#FFF", padding: "6px" }}>
                ON PROGRESS
              </span>
            );
          } else if (item.incident_status == "REJECTED" || item.incident_status_detail == "REJECTED") {
            return (
              <span className="badge badge-danger" style={{ color: "#FFF", padding: "6px" }}>
                REJECTED
              </span>
            );
          } else if (item.incident_status == "ONREVISED" || item.incident_status_detail == "ONREVISED") {
            return (
              <span className="badge badge-warning" style={{ color: "#FFF", padding: "6px" }}>
                NEED REVISION
              </span>
            );
          } else {
            return (
              <span className="badge badge-warning" style={{ color: "#FFF", padding: "6px" }}>
                PENDING
              </span>
            );
          }
        } else {
          if (item.incident_status == "ONPROGRESS" || item.incident_status_detail == "ONPROGRESS") {
            return (
              <span className="badge badge-info" style={{ color: "#FFF", padding: "6px" }}>
                ON PROGRESS
              </span>
            );
          } else if (item.incident_status == "ONREVISED" || item.incident_status_detail == "ONREVISED") {
            return (
              <span className="badge badge-warning" style={{ color: "#FFF", padding: "6px" }}>
                NEED REVISION
              </span>
            );
          } else if (
            (item.incident_status == "COMPLETED" || item.incident_status_detail == "COMPLETED") &&
            !item.incident_status &&
            item.is_creation_approved == true
          ) {
            if (item.incident_status_detail == "COMPLETED")
              return (
                <span className="badge badge-success" style={{ color: "#FFF", padding: "6px" }}>
                  COMPLETED
                </span>
              );
            else
              return (
                <span className="badge badge-success" style={{ color: "#FFF", padding: "6px" }}>
                  VALIDATED
                </span>
              );
          } else if (item.incident_status == "REJECTED" || item.incident_status_detail == "REJECTED") {
            return (
              <span className="badge badge-danger" style={{ color: "#FFF", padding: "6px" }}>
                REJECTED
              </span>
            );
          } else if (
            item.incident_status == "NOT SUBMITTED" ||
            item.incident_status_detail == "NOT SUBMITTED" ||
            (!item.incident_status && !item.incident_status_detail)
          ) {
            return (
              <span className="badge badge-success" style={{ color: "#FFF", padding: "6px" }}>
                VALIDATED
              </span>
            );
          }
        }
      },
    },
  ];

  const onRowChecked = (checked) => {
    setState({ ...state, checked });
  };

  const filterAction = () => {
    if (params) {
      const obj = Object.keys(params);
      setState({ ...state, customFilter: `${obj[0]}:${state.params[obj[0]]}` });
    } else {
      setState({ ...state, customFilter: null });
    }
  };

  const onCloseModal = () => {
    $(modalId).modal("hide");
  };

  const onView = () => {
    $(modalId).modal("hide");
    setTimeout(() => {
      navigate(`/product-view/detail/${selectedItem.country_code}/${selectedItem.item_code} `);
    }, 50);
  };

  const filterForm = (
    <div className="row p-1">
      <div className="col-md-12">
        <div className="form-group">
          <label htmlFor="prefix">Product Segment</label>
          <select className="form-control" name="id_segment" onChange={setChange}>
            <option value="">Select Segment</option>
            {state.segments.map((item, i) => {
              return (
                <option value={item.id} key={i}>
                  {item.segment_name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <div className="col-md-12">
        <div className="form-group">
          <label htmlFor="prefix">Product Category</label>
          <select className="form-control" name="id_category" onChange={setChange}>
            <option value="">Select Category</option>
            {state.categories.map((item, i) => {
              return (
                <option value={item.id} key={i}>
                  {item.category_name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <div className="col-md-12">
        <div className="form-group">
          <label htmlFor="prefix">Product Subcategory</label>
          <select className="form-control" name="id_sub_category" onChange={setChange}>
            <option value="">Select Subcategory</option>
            {state.subcategories.map((item, i) => {
              return (
                <option value={item.id} key={i}>
                  {item.sub_category_name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>
  );

  const { processing2, customFilter, params, selectedItem, checked, checkAll } = state;

  const showAllFunc = () => {
    setShowAll(!showAll);
    mTable.current.refresh();
  };

  const propsTable = {
    columns,
    showAllState: null,
    showAllFunc,
    getData: (params) => {
      if (params.filter) params.filter += "," + `is_active:true`;
      else params.filter = "is_active:true";

      return getProductsAll({ ...params });
    },
    showIndex: true,
    showAddButton: false,
    onAddData,
    filterChilds: { view: filterForm, action: filterAction },
    enableFilter: true,
    rowClick: onRowClick,
    rowSelector: "item_code",
    orders: "sort:desc",
    checked,
    checkAll,
    onChecked: onRowChecked,
  };

  useEffect(() => {
    const reqSegment = getSegmentAll({ perpage: 1000 }).then((res) => res.data.data);
    const reqLang = getLanguages({
      orders: "language_name:asc",
      perpage: 1000,
    }).then((res) => res.data.data);
    const reqExportFile = getExportFile("product_master").then((res) => res.data);
    const reqImport = getImportFile("product_master").then((res) => res.data);
    const reqAssemble = getAllAssembles({ perpage: 1000 }).then((res) => res.data.data);
    Promise.all([reqSegment, reqLang, reqExportFile, reqImport, reqAssemble]).then((results) => {
      const [_segment, _langs, _fileExport, _fileImport, _assembles] = results;
      const fExport = _fileExport.status != 404 ? _fileExport : null;
      const fImport = _fileImport.status != 404 ? _fileImport : [];
      setTimeout(() => {
        setState({
          ...state,
          languages: _langs,
          fileExport: fExport,
          files: fImport,
          segments: _segment,
          assembles: _assembles,
        });
      }, 100);
    });
  }, []);

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-4">
              <h4 style={{ marginTop: "0.5rem", marginLeft: "0.2rem", fontWeight: "400" }}>Product Data Management View</h4>
              <h6 style={{ marginLeft: "0.2rem", fontWeight: "200", letterSpacing: "1.2px" }}>Your central hub for product information</h6>
            </div>
            <div className="col-sm-8">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <NavLink to="/home">Home</NavLink>
                </li>
                <li className="breadcrumb-item active">Products</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <Overlay display={processing2} />
                <div className="card-body">
                  <div className="col-md-12">
                    <MTable ref={mTable} {...propsTable} showIndex={true} customFilter={customFilter} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal
        id={modalId}
        title={"Product Overview"}
        onClose={onCloseModal}
        modalSize="modal-lg"
        btnActionName="View Product"
        disabledBtnSecond={true}
        onAction={userInfo.access.master_product_view?.can_view ? onView : undefined}
        onSecondAction={undefined}
      >
        {selectedItem && (
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>SKU Number</label>
                <p className="mt-n2">{selectedItem.item_code}</p>
              </div>

              <div className="form-group">
                <label>Dimensions</label>
                <div className="mt-n2">
                  Height: <span className="text-bold">{selectedItem.height} mm</span>
                </div>
                <div>
                  Width: <span className="text-bold">{selectedItem.width} mm</span>
                </div>
                <div>
                  Length: <span className="text-bold">{selectedItem.length} mm</span>
                </div>
                <div>
                  Weight: <span className="text-bold">{selectedItem.weight} kg</span>
                </div>
                <div>
                  Volume: <span className="text-bold">{selectedItem.volume} kgv</span>
                </div>
              </div>

              <div className="form-group">
                <label>Package Dimensions</label>
                <div className="mt-n2">
                  Outer Height: <span className="text-bold">{selectedItem.outer_height} mm</span>
                </div>
                <div>
                  Outer Width: <span className="text-bold">{selectedItem.outer_width} mm</span>
                </div>
                <div>
                  Outer Weight: <span className="text-bold">{selectedItem.outer_weight} kg</span>
                </div>
                <div>
                  Outer Length: <span className="text-bold">{selectedItem.outer_length} mm</span>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mt-n2">
                <label>Segment</label>
                <p className="mt-n2">{selectedItem.segment_name}</p>
              </div>
              <div className="form-group mt-n2">
                <label>Category</label>
                <p className="mt-n2">{selectedItem.category_name}</p>
              </div>
              <div className="form-group mt-n2">
                <label>Subcategory</label>
                <p className="mt-n2">{selectedItem.sub_category_name}</p>
              </div>
              {selectedItem.country_code && (
                <div className="form-group mt-n2">
                  <label>Country</label>
                  <p className="mt-n2">
                    <CountryFlag code={selectedItem.country_code} />
                    {selectedItem.country_name ? selectedItem.country_name : "Name Unknown"}
                  </p>
                </div>
              )}
              <div className="form-group">
                <label>Is Active</label>
                <p className="mt-n2">{selectedItem.is_active ? <span className="text-success">Active</span> : <span className="text-danger">Inactive</span>}</p>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ProductPageView;
